import {Schema, String, filter} from 'effect/Schema';
import isISO31661Alpha2 from 'validator/lib/isISO31661Alpha2';

const CountryCodeAlpha2Schema = String.pipe(
    filter(isISO31661Alpha2, {
        identifier: 'CountryCodeAlpha2',
    })
);

export const CountryCodeAlpha2 = CountryCodeAlpha2Schema as unknown as Schema<CountryCodeAlpha2>;
export type CountryCodeAlpha2 = import('../src/CountryCodeAlpha2').CountryCodeAlpha2;
